import script from "./grossProfitReport.vue?vue&type=script&setup=true&lang=js"
export * from "./grossProfitReport.vue?vue&type=script&setup=true&lang=js"

import "./grossProfitReport.vue?vue&type=style&index=0&id=2e0a921a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e0a921a"]])

export default __exports__